const IOS_DEVICE_PATTERN = /iPad|iPhone|iPod/;

export const isIosDevice = (nav = typeof navigator !== "undefined" ? navigator : undefined) => {
    if (!nav) {
        return false;
    }
    if (IOS_DEVICE_PATTERN.test(nav.userAgent || "")) {
        return true;
    }
    // iPadOS 13+ reports itself as Macintosh; tell it apart via touch support.
    return nav.platform === "MacIntel" && Number(nav.maxTouchPoints) > 1;
};

/**
 * iOS Safari auto-zooms the page when a focused field's font size is below
 * 16px — and on some versions it zooms contenteditable fields regardless,
 * which wrecks fixed-height app layouts like the chat page.
 *
 * `maximum-scale=1` suppresses that auto-zoom, but it must not live in the
 * static viewport meta: Android browsers honor it and would lose pinch-zoom
 * entirely (a WCAG 1.4.4 violation). iOS Safari has ignored the cap for user
 * pinch gestures since iOS 10, so applying it at runtime on iOS only keeps
 * pinch-zoom working everywhere while killing the focus auto-zoom where it
 * actually happens.
 */
export const applyIosViewportZoomFix = (
    doc = typeof document !== "undefined" ? document : undefined,
    nav = undefined,
) => {
    if (!doc || !isIosDevice(nav)) {
        return false;
    }
    const meta = doc.querySelector('meta[name="viewport"]');
    if (!meta) {
        return false;
    }
    const content = meta.getAttribute("content") || "";
    if (/maximum-scale/i.test(content)) {
        return false;
    }
    meta.setAttribute("content", `${content}, maximum-scale=1`);
    return true;
};

export default applyIosViewportZoomFix;
